
import {useState,useRef} from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Translate from '../components/Translate';
import Scanner from '../components/Scanner';
import ToggleInput from '../components/ToggleInput';
/*
   @payment
   @input 
   @result
     <span className ='btn btn-sm btn-danger rounded'>
                                    <i className ='fa fa-barcode ' style ={{fontSize:'150%'}}></i>
                               </span>
*/
const Online = ()=>{

    const [value,setValue] = useState('');

    const [toggle,setToggle] = useState(true);
    const buttonRef = useRef(null);


    const handleScan = (result)=>{
        setValue(result);
        buttonRef.current.click();
    };
  
    return (
        <>
   
            {toggle && (
                <div className ='row my-2'>
                  <div className ='form-group mx-auto' style ={{minWidth:'350px'}}>
                       <label><Translate k='trackingNumber' /><sup>*</sup></label>
                       <div className = 'input-group'>
                           <input 
                               type ='text' 
                               className ='form-control eparts-input' 
                               placeholder ='...'
                               readOnly = {true}
                               value = {value || ''}
                               ref = {buttonRef}
                              
                           />
                           <div className ='input-group-append'>
                               <Scanner 
                                  url = {`${window.location.href}`} 
                                  callBack = { handleScan }
                                 
                              />
                           </div>
                       </div>
                  </div>
                </div>
           )}

        
            <div className ='row' style = {{position:'relative'}}>
                  <ToggleInput handleToggle = {()=>setToggle(!toggle)}/>
            </div>

                
            <Tabs defaultActiveKey="home">
                <Tab eventKey="home" 
                    className ='rounded' 
                    style = {{fontSize:'85%'}}
                    title={ 
                        <>
                        <i className ='fa fa-list mr-2'></i>
                        <Translate k= {'home'} />
                        </>
                    } 
                >


                
                    <div 
            
                        style ={{
                                marginTop:'8vh',
                                minHeight:'350px',
                                backgroundImage:'url('+require('../images/pallet.jpg')+')',
                                backgroundPosition: 'center',
                                backgroundSize: '80%',
                                backgroundRepeat: 'no-repeat',
                        }}
                    >
                    ...
                    </div>
                   


                </Tab>
            </Tabs>
                    
            
            
        
        </>
    );

};

export default Online;
